import { State } from "../state";

export interface SelectPageAction {
  page: number;
  type: "SELECT PAGE";
}

export const selectPage = (state: State, action: SelectPageAction): State => {
  if (action.page === state.activePage) {
    return state;
  }
  if (!state.pages[action.page]) {
    throw new Error("Invalid page number.");
  }
  return {
    ...state,
    activePage: action.page,
    previousPage: state.activePage,
  };
};
